import { useTranslation } from 'react-i18next';
import './UnitSwitch.css';

/* Bascule CHF / kCHF — source unique. DEPUIS LE 2026-09-30, une bascule
   TEXTE discrète (« CHF · kCHF », l'unité retenue en gras) : c'est une
   préférence d'affichage, elle ne doit pas attirer l'œil plus que la version
   ou l'exercice, qui changent les chiffres. Props : value = 'chf' | 'kchf' ;
   onChange(next). */
export default function UnitSwitch({ value, onChange }) {
  const { t } = useTranslation();
  const toggle = () => onChange(value === 'kchf' ? 'chf' : 'kchf');
  return (
    <div
      className="unit-switch"
      role="switch"
      aria-checked={value === 'kchf'}
      aria-label={t('phrases:p_ddc0626012')}
      tabIndex={0}
      onClick={toggle}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } }}
    >
      <span className={`unit-switch__lab${value === 'chf' ? ' on' : ''}`}>CHF</span>
      <span className="unit-switch__sep" aria-hidden="true">·</span>
      <span className={`unit-switch__lab${value === 'kchf' ? ' on' : ''}`}>kCHF</span>
    </div>
  );
}
